import styled from 'styled-components';

import Text from '~components/Text';

function DeletedContent() {
  return (
    <Wrapper>
      <img src='https://image.wanted.co.kr/kreditjob/www/sigh.png' alt='sigh face' />
      <Text typography='midium120_B1'>더 이상 유효하지 않은 기업입니다.</Text>
    </Wrapper>
  );
}

export default DeletedContent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 48px auto 60px auto;

  & > img {
    width: 120px;
    margin-bottom: 8px;
  }

  & > span {
    color: ${({ theme }) => theme.colors.gray700};
  }
`;
